import { useState } from "react";
import { Select } from "../../../components/Select";
import { Input } from "../../../components/Input";

export function CredentialStep({ environment, appId, appSecret, onChange }) {
  return (
    <>
      <Select
        design="two"
        label="Ambiente"
        onChange={(e) => onChange({ environment: e.target.value })}
        className="mb-20"
        value={environment}
        options={[
          {
            label: "Produção",
            value: "PRODUCTION",
            selected: environment === "PRODUCTION",
          },
          {
            label: "Homologação",
            value: "SANDBOX",
            selected: environment === "SANDBOX",
          },
        ]}
      />
      <Input
        design="two"
        className="mb-20"
        floatLabel="App Id"
        value={appId}
        onChange={(e) => onChange({ appId: e.target.value })}
      />
      <Input
        design="two"
        className="mb-20"
        floatLabel="App Secret"
        value={appSecret}
        onChange={(e) => onChange({ appSecret: e.target.value })}
      />
    </>
  );
}
